import { formatLocalityParts } from "@/utils/formatLocality";

interface Props {
  /** Full dropoff point name, e.g. "CURITIBA GARAGEM". */
  name?: string | null;
  /** Authoritative city name when the API sends it separately. */
  cityName?: string | null;
  /** Optional state/UF rendered after the qualifier, in the muted style. */
  state?: string | null;
  /** Style of the boarding-point qualifier (and state), muted by default. */
  mutedClassName?: string;
}

/**
 * Renders a locality as "Curitiba (Garagem)" with the qualifier in a lighter
 * tone than the city. Inline-only — the caller owns the wrapping element.
 */
const LocalityLabel = ({
  name,
  cityName,
  state,
  mutedClassName = "font-normal text-slate",
}: Props) => {
  const { city, qualifier } = formatLocalityParts(name, cityName);
  const uf = (state ?? "").trim();

  return (
    <>
      {city}
      {qualifier && (
        <span className={mutedClassName}>
          {city ? ` (${qualifier})` : qualifier}
        </span>
      )}
      {uf && <span className={mutedClassName}> - {uf}</span>}
    </>
  );
};

export default LocalityLabel;
